<template>
  <div>
    <div class="container">
      <div class="handle-box">
        <el-cascader :props="props" v-model="area_store" placeholder="选择或搜索门店" collapse-tags clearable
          filterable></el-cascader>
        <el-select v-model="query.order_type" clearable placeholder="订单类型" style="width: 200px;margin-right: 4px;"
          @clear="clearType">
          <el-option v-for="itm in ORDER_TYPE" :key="itm.value" :label="itm.label" :value="Number(itm.value)"
            @click="getStatusMap(itm.payType)"></el-option>
        </el-select>

        <el-select v-model="query.type" clearable placeholder="收款类型" style="width: 200px;margin-right: 4px;">
          <el-option v-for="itm in PAY_TYPE" :key="itm.value" :label="itm.label" :value="Number(itm.value)"></el-option>
        </el-select>

        <el-input v-model="query.order_title" style="width:180px;" placeholder="订单标题"></el-input>
        <el-input v-model="query.order_no" style="width:180px;" placeholder="订单编号"></el-input>
        <el-input v-model="query.real_name" style="width:100px;" placeholder="客户称呼"></el-input>
        <el-input v-model="query.phone" style="width:130px;" placeholder="客户手机号"></el-input>
        <el-date-picker v-model="value1" type="datetimerange" value-format="YYYY-MM-DD HH:mm:ss"
          format="YYYY-MM-DD HH:mm:ss" align="right" start-placeholder="开始日期" end-placeholder="结束日期"
          :default-time="['0000-00-00 00:00:00', '3000-00-00 23:59:59']" style="margin-right: 10px;">
        </el-date-picker>
        <el-button type="primary" class="export-excel-wrapper" icon="el-icon-search"
          @click="handleSearch">搜索</el-button>
        <vue3-json-excel class="export-excel-wrapper" :json-data="json_data" :fields="json_fields"
          :before-generate="handleDownload" name="收入.xls">
          <el-button icon="el-icon-download"> 导出</el-button>
        </vue3-json-excel>
        <el-tooltip class="item" effect="dark" content="收入导出时必须选择时间段，并且一次性最多只能导出3个月的内容" placement="top-start">
          <el-button class="el-button-problem" icon="el-icon-warning-outline" type="text"></el-button>
        </el-tooltip>
      </div>
      <el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header">
        <el-table-column type="expand" width="30">
          <template #default="scope">
            <el-row :gutter="40" v-if="scope.row.integral != null">
              <el-col :div="40">
                积分状态：<span class="order-field">{{ integralMap.get(scope.row.integral.type) }}</span>
                积分类型：<span class="order-field">{{ scope.row.integral.memo }}</span>
                {{ (scope.row.integral.type) != 2 ? '获得' : '使用' }}数量：<span>{{ scope.row.integral.score }}</span>
                {{ (scope.row.integral.type) != 2
                  ? '可抵金额' : '抵扣金额' }}：<span>{{ (scope.row.integral.score / 100).toFixed(2) }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.order_voucher">
              <el-col :div="40">
                卡券名称：<span class="order-field">{{ scope.row.order_voucher.name }}</span>
                卡券价格：<span class="order-field">{{ scope.row.order_voucher.price }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.order_coupon != null">
              <el-col :div="40">
                优惠名称：<span>{{ scope.row.order_coupon.name }}</span>
                优惠金额：<span>{{ (scope.row.order_coupon.use_amount / 100).toFixed(2) }}</span>
                起止时间：<span>{{ ForMatHMS(scope.row.order_coupon.start_time) }}</span><span
                  style="margin-left: 10px;">-</span>
                <span>{{ ForMatHMS(scope.row.order_coupon.end_time) }}</span>
                优惠说明：<span>{{ scope.row.order_coupon.memo }}</span>
              </el-col>
            </el-row>
            <el-row :gutter="40" v-if="scope.row.order_type != null">
              <el-col :div="40">
                订单类型：<span>{{ orderMap.get(scope.row.order_type) }}</span>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <!--<el-table-column prop="id" label="ID" width="55" align="center"></el-table-column>-->
        <el-table-column prop="store_name" label="门店" :show-overflow-tooltip="true" width="140" align="center">
          <template #default="scope">{{ scope.row.store_name != "" ? scope.row.store_name : "平台" }}</template>
        </el-table-column>
        <el-table-column label="订单编号" width="130">
          <template #default="scope">
            <el-button type="text" :style="'color:#409EFF'" @click="showDetail(scope.row.order_id)">
              {{ scope.row.no }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="order_title" label="订单标题" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="nickname" label="客户" width="80" :show-overflow-tooltip="true">
          <template #default="scope">{{ scope.row.real_name || scope.row.nickname }}</template>
        </el-table-column>
        <el-table-column prop="phone" label="客户手机号" width="110"></el-table-column>
        <el-table-column prop="money" label="订单金额" align="right" width="100">
          <template #header>
            <span>订单金额</span>
            <el-tooltip class="box-item" effect="dark" content="订单金额：即该订单包括使用套餐之后的总金额" placement="top">
              <el-button icon="el-icon-warning" type="text" style="color: #777"></el-button>
            </el-tooltip>
          </template>
          <template #default="scope">{{ (scope.row.order_meal ? (scope.row.order_meal.price / 100) :
            (scope.row.total_money / 100)).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="money" label="优惠金额" align="right" width="100">
          <template #header>
            <span>优惠金额</span>
            <el-tooltip class="box-item" effect="dark" content="优惠金额：即该订单所使用的优惠的总和（包括优惠券和积分），具体优惠详情可点击左侧三角进行查看"
              placement="top">
              <el-button icon="el-icon-warning" type="text" style="color: #777"></el-button>
            </el-tooltip>
          </template>
          <template #default="scope">{{ ((scope.row.order_meal ? (scope.row.order_meal.price / 100) :
            (scope.row.total_money / 100)) - (scope.row.money / 100)).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="money" label="支付金额" align="right" width="100">
          <template #header>
            <span>支付金额</span>
            <el-tooltip class="box-item" effect="dark" content="支付金额：即该订单用户支付的金额（未扣除手续费）" placement="top">
              <el-button icon="el-icon-warning" type="text" style="color: #777"></el-button>
            </el-tooltip>
          </template>
          <template #default="scope">{{ (scope.row.money / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="money" label="已退金额" align="right" width="100">
          <template #header>
            <span>已退金额</span>
            <el-tooltip class="box-item" effect="dark" content="已退金额：即该订单目前以退回给用户账户的金额" placement="top">
              <el-button icon="el-icon-warning" type="text" style="color: #777"></el-button>
            </el-tooltip>
          </template>
          <template #default="scope">{{ (scope.row.refund_money / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="finally_received_money" label="到账金额" align="right" width="100">
          <template #header>
            <span>到账金额</span>
            <el-tooltip class="box-item" effect="dark" content="到账金额金额：完成支付或线下转账后，再扣除掉各类手续费、优惠费用后实际到达加盟商账户的金额"
              placement="top">
              <el-button icon="el-icon-warning" type="text" style="color: #777"></el-button>
            </el-tooltip>
          </template>
          <template #default="scope">{{ (scope.row.finally_received_money / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="merchant_settlement_money" label="平台结算" align="right" width="100">
          <template #header>
            <span>平台结算</span>
            <el-tooltip class="box-item" effect="dark" content="平台结算金额：即存在支付方式未平台通用余额的情况时，除去系数比例之后的金额，系数比例是0.9"
              placement="top">
              <el-button icon="el-icon-warning" type="text" style="color: #777"></el-button>
            </el-tooltip>
          </template>
          <template #default="scope">{{ (scope.row.merchant_settlement_money / 100).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="pay_type_name" label="收款方式" width="100" align="center">
          <template #default="scope">{{ scope.row.pay_type_name }}</template>
        </el-table-column>
        <el-table-column prop="transaction_id" label="收款编号" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="balance_store_name" label="余额类型" width="140" align="center">
          <template #default="scope">{{ (scope.row.order_title != '充值') ? scope.row.balance_store_name : ''
            }}</template>
        </el-table-column>
        <el-table-column prop="order_status" label="订单状态" width="80" align="center">
          <template #default="scope">{{ statusMap.get(scope.row.order_status) }}</template>
        </el-table-column>
        <el-table-column prop="c_at" :formatter="dateFormatHMS" label="收款时间" width="170">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="query.page"
          :page-sizes="[10, 20, 50, 100, 200, 500]" :page-size="10" layout="total,sizes, prev, pager, next"
          :total="pageTotal">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="订单详情" v-model="detailVisible" width="40%" :before-close="handleClose">
      <div class="list_box">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">订单编号</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.no }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">用户昵称</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.nickname }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">手机号</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.phone }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">门店</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.store_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">订单类型</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.type_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">订单状态</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.status_name }}</div>
          </el-col>
        </el-row>
      </div>
      <div v-if="theDetail.time_order_list != null && theDetail.time_order_list.length > 0">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">开始时间</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ ForMatHMS(theDetail.time_order_list.start_time) }} </div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">结束时间</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ ForMatHMS(theDetail.time_order_list.end_time) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">加时时长</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{
              ((theDetail.time_order_list.end_time - theDetail.time_order_list.start_time) / 3600).toFixed(1) }}小时</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">加时价格</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.time_order_list.price / 100).toFixed(2) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">加时订单</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.time_order_list.no }}</div>
          </el-col>
        </el-row>
      </div>

      <div v-if="theDetail.order_room !== null">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">开始时间</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ ForMatHMS(theDetail.order_room.start_time) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">结束时间</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ ForMatHMS(theDetail.order_room.end_time) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">房间时长</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.order_room.end_time -
              theDetail.order_room.start_time) / 3600 }}小时</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">房间价格</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.order_room.price / (100)).toFixed(2) }}</div>
          </el-col>
        </el-row>
      </div>

      <div v-if="theDetail.order_meal !== null">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">套餐</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_meal.meal_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">时长</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_meal.hour }}小时</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">价格</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.order_meal.price / 100).toFixed(2) }}</div>
          </el-col>
        </el-row>
      </div>

      <div v-if="theDetail.product_list.length > 0">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">商品名称</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.product_list[0].product_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">规格名称</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.product_list[0].specs_name }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">数量</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.product_list[0].num }}</div>
          </el-col>
        </el-row>
      </div>

      <div v-if="theDetail.order_address != null">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">收货人</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.consignee }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">联系方式</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.mobile }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">省市区</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">
              {{ theDetail.order_address.province + theDetail.order_address.city + theDetail.order_address.area }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">详细地址</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.content }}</div>
          </el-col>
        </el-row>
      </div>

      <div v-if="theDetail.order_address != null">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">收货人</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.consignee }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">联系方式</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.mobile }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">省市区</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">
              {{ theDetail.order_address.province + theDetail.order_address.city + theDetail.order_address.area }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">详细地址</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ theDetail.order_address.content }}</div>
          </el-col>
        </el-row>
      </div>
      <div v-if="theDetail.type === 5">
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">充值金额</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.order_balance.charge / 100).toFixed(2) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">赠送金额</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">
              {{ ((theDetail.order_balance.deposit - theDetail.order_balance.charge) / 100).toFixed(2) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">到账金额</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.order_balance.deposit / 100).toFixed(2) }}</div>
          </el-col>
        </el-row>
        <el-row :gutter="16">
          <el-col :span="6">
            <div class="grid-content bg-purple">通用类型</div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple">{{ (theDetail.store_id == 0 ? "平台通用" : theDetail.store_name) }}</div>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="16">
        <el-col :span="6">
          <div class="grid-content bg-purple">备注</div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content bg-purple">{{ theDetail.memo }}</div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import {
  payList,
  getDetail,
  orderPayType
} from "@/api/finance";
import moment from "moment";
import { getAreaOption, getStoreOption } from "@/api/store";
import { ElTableColumn } from "element-plus";
import { status } from "@/constant/status";
export default {
  name: "financetable",
  components: { ElTableColumn },
  computed: {
    status() {
      return status
    }
  },
  data() {
    return {
      detailVisible: false,
      query: {
        store_id: null,
        order_no: "",
        real_name: "",
        nickname: '',
        phone: "",
        add_start: null,
        add_end: null,
        add_start_utc: null,
        add_end_utc: null,
        page: 1,
        page_size: 10,
        type: '',
        order_type: '',
        order_title: ''
      },
      apply_query: {
        status: null,
        order_no: "",
        transaction_id: "",
        no: "",
        nickname: "",
        phone: "",
        add_start: null,
        add_end: null,
        add_start_utc: null,
        add_end_utc: null,
        page: 1,
        page_size: 10
      },
      typeList: [],
      payType: [],
      storeOptions: [], // 门店信息
      applyStatusOptions: [], // 退款申请状态
      applyStatusMap: new Map(),
      tableData: [],
      tabName: '收入',
      pageTotal: 0,
      applyPageTotal: 0,
      json_fields: { //如果命名的标题有空格,需要用双引号
        门店: "store_type_name",
        订单编号: "no",
        收款编号: "transaction_id",
        客户名称: "name",
        客户手机号: "phone",
        订单金额: "order_money",
        优惠金额: "yh_money",
        支付金额: "money",
        到账金额: "finally_received_money",
        平台结算: "merchant_settlement_money",
        已退金额: "refund_money",
        收款方式: "pay_type_name",
        余额类型: "balance_store_name",
        订单状态: "status",
        订单类型: "type",
        收款时间: "at",
      },
      json_data: [],
      json_meta: [
        [
          {
            " key ": " charset ",
            " value ": " utf- 8 "
          }
        ]
      ],
      theDetail: {},
      value1: [],
      value2: [],
      typeMap: new Map(),
      integralMap: new Map(),
      integralList: [
        { value: 1, label: '赠送' },
        { value: 2, label: '使用' },
        { value: 3, label: '退回' },
        { value: 4, label: '待进账' }
      ],
      orderMap: new Map(),
      statusMap: new Map(),
      areaOptions: [],
      area_store: [],
      props: {
        lazy: true,
        lazyLoad: this.lazyLoad
      },
      moenyVisible: false,
      moneyForm: {
        id: null,
        amount: ''
      },
      surpluseMoney: 0,
      PAY_TYPE: [],
      ORDER_TYPE: []

    }
  },
  created() {
    this.getData()
    this.getIntegral()
    this.getOrderTypeMap()
  },
  methods: {
    getIntegral() {
      this.integralList.forEach(item => {
        this.integralMap.set(item.value, item.label)
      })
    },
    clearType() {
      this.PAY_TYPE = []
    },
    getStatusMap(status) {
      this.PAY_TYPE = status
      this.status.forEach(item => {
        this.statusMap.set(item.value, item.label)
      })
    },
    getOrderTypeMap() {
      let order_type = []
      orderPayType().then(res => {
        order_type = res
        this.ORDER_TYPE = res
        this.getStatusMap(res[0].payType)
        order_type.forEach(item => {
          this.orderMap.set(item.value, item.label)
        })
      })
    },
    ForMatHMS(date) {
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    dateFormatHMS: function (row, column) {
      const date = row[column.property];
      if (date === undefined || date === 0) {
        return "";
      }
      return moment(parseInt(date + "000")).format("YYYY-MM-DD HH:mm:ss")
    },
    handleSearch() {
      this.query.page = 1
      this.getData()
    },

    // 收入导出
    async handleDownload() {
      if ((this.value1 != null) && (this.value1.length != 0)) {
        this.query.add_start = moment(this.value1[0]).unix()
        this.query.add_end = moment(this.value1[1]).unix()
      } else if (this.value1 == null) {
        this.query.add_start = null
        this.query.add_end = null
      }
      let start_time = this.query.add_start
      let end_time = this.query.add_end

      let isNineThree = (end_time - start_time) < 8035200
      if (start_time != null && end_time != null && isNineThree) {
        this.json_data = []
        this.query.page_size = -1
        await payList(this.query).then(res => {
          let that = this
          res.data.forEach(item => {
            item.name = item.real_name || item.nickname
            item.store_type_name = item.store_name || '平台'
            item.balance_store_name = (item.order_title != '充值') ? item.balance_store_name : ''
            item.no += '&nbsp;'
            item.order_money = item.order_meal ? (item.order_meal.price / 100).toFixed(2) : (item.total_money / 100).toFixed(2)
            item.money /= 100
            item.finally_received_money /= 100
            item.merchant_settlement_money /= 100
            item.yh_money = ((item.order_meal ? (item.order_meal.price / 100) : item.total_money / 100) - item.money).toFixed(2)
            item.status = this.statusMap.get(item.order_status)
            item.type = this.orderMap.get(item.order_type)
            item.refund_money /= 100
            if (item.c_at === 0) {
              item.at = "";
            } else {
              item.at = moment(parseInt(item.c_at + "000")).format("YYYY-MM-DD HH:mm:ss")
            }
            that.json_data.push(item)
          })
          this.query.page_size = 10
        })
      } else if (start_time == null || end_time == null) {
        this.$message.error('请选择开始日期和结束日期，最多可导出3个月的数据')
      } else if (!isNineThree) {
        this.$message.error('只能同时导出最多3个月的数据，请重新选择开始时期和结束时期')
      }

    },
    getStoreOption(id) {
      getStoreOption(id).then(res => {
        this.storeOptions = res
      })
    },

    lazyLoad(node, resolve) {
      const { level } = node;
      if (level === 0) {
        this.getAreaOptions()
        let nodes = []
        if (this.areaOptions !== []) {
          setTimeout(() => {
            nodes = this.areaOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level >= 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }
      if (level === 1) {
        let nodes = []
        this.getStoreOption(node.value)
        if (this.storeOptions !== []) {
          setTimeout(() => {
            nodes = this.storeOptions.map(item => ({
              value: item.value,
              label: item.label,
              leaf: level >= 1
            }));
            // 通过调用resolve将子节点数据返回，通知组件数据加载完成
            resolve(nodes);
          }, 500);
        }
      }

    },
    // 获取地址列表
    getAreaOptions() {
      getAreaOption().then(res => {
        this.areaOptions = res
      })
    },

    getData() {
      this.query.area_id = this.area_store !== null ? this.area_store[0] : null
      this.query.store_id = (this.area_store !== null && this.area_store.length > 1) ? this.area_store[1] : null
      if ((this.value1 != null) && (this.value1.length != 0)) {
        this.query.add_start = moment(this.value1[0]).unix()
        this.query.add_end = moment(this.value1[1]).unix()
      } else if (this.value1 == null) {
        this.query.add_start = null
        this.query.add_end = null
      }

      payList(this.query).then(res => {
        res.data.forEach(item => {
          item.content = JSON.parse(JSON.stringify(item.content))
        })
        this.tableData = res.data
        if (this.query.page === 1) {
          this.pageTotal = res.count
        }
      })
    },
    // 分页导航
    handlePageChange(val) {
      this.query.page = val
      this.getData()
    },
    handleSizeChange(val) {
      this.query.page_size = val
      this.getData()
    },

    //   详情展示
    showDetail(id) {
      let that = this
      getDetail(id).then(res => {
        this.theDetail = res
        that.detailVisible = true
      })

    },
    handleClose() {
      this.detailVisible = false
    },
    handleMoenyClose() {
      this.moenyVisible = false
    },
  }
}

</script>

<style scoped>
.handle-box {
  margin-bottom: 10px;
}

.el-input {
  width: 250px;
  display: inline-block;
  margin-right: 5px;

}

.el-select {
  width: 250px;
  margin-right: 10px;
  margin-bottom: 15px;
}

.table {
  width: 100%;
  font-size: 14px;
}

.warning {
  color: #e6a23c;
}

.export-excel-wrapper {
  margin-left: 10px;
}

.order-field {
  color: blue;
}

.el-row {
  margin-bottom: 10px;
}

.el-col {
  border-radius: 4px;

}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple-light {
  background: #f9f9fc;
}

.grid-content {
  border-radius: 4px;
  min-height: 24px;
  text-align: center;
  line-height: 24px;
}

.row-bg {
  padding: 5px 0;
  background-color: #f9fafc;
}

.el-dialog__body div {
  margin: 0 auto;
  margin-bottom: 5px;
}

.el-col span {
  margin-right: 30px;
}

/deep/.el-tabs__item {
  width: 100px;
  text-align: center;
}

/deep/.el-cascader {
  margin-right: 5px;
}

.el-button-problem {
  font-size: 20px;
  margin-left: 10px;
  margin-top: 15px;
}
</style>
